import { apiService } from "./api";

export interface Wilaya {
  id: number;
  name: string;
  name_ar: string;
  name_ascii: string;
  code: string;
}

export interface Commune {
  id: number;
  commune_name: string;
  commune_name_ascii: string;
  daira_name?: string;
  daira_name_ascii?: string;
  wilaya_code: string;
  wilaya_name?: string;
  wilaya_name_ascii?: string;
}

export const locationService = {
  async getWilayas(): Promise<Wilaya[]> {
    return await apiService.get<Wilaya[]>("/locations/wilayas");
  },

  async getCommunesByWilaya(wilayaCode: string): Promise<Commune[]> {
    return await apiService.get<Commune[]>(
      `/locations/wilayas/${wilayaCode}/communes`
    );
  },
};

